export const statusDict = {
  NONE: `ord.impossible_export`,
  SUCCESS: `ord.exported`,
  PENDING: `ord.export_planned`,
  ERROR: `just_words.w4`,
};
